/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  MESSAGE_CLEAN_REQUEST,
  SINGLE_MESSAGE_CLEAN_REQUEST,
  MESSAGE_ADD_REQUEST,
  MESSAGE_ADD_REQUEST_SUCCESS,
  MESSAGE_ADD_REQUEST_FAILURE,
  MESSAGE_FETCH_REQUEST,
  MESSAGE_FETCH_REQUEST_SUCCESS,
  MESSAGE_FETCH_REQUEST_FAILURE,
  SINGLE_MESSAGE_FETCH_REQUEST,
  SINGLE_MESSAGE_FETCH_REQUEST_SUCCESS,
  SINGLE_MESSAGE_FETCH_REQUEST_FAILURE,
  MESSAGE_TEMPLATE_FETCH_REQUEST,
  MESSAGE_TEMPLATE_UPSERT_REQUEST,
  MESSAGE_TEMPLATE_FETCH_REQUEST_SUCCESS,
  MESSAGE_TEMPLATE_UPSERT_REQUEST_SUCCESS,
  MESSAGE_TEMPLATE_FETCH_REQUEST_FAILURE,
  MESSAGE_TEMPLATE_UPSERT_REQUEST_FAILURE,
  MESSAGE_TEMPLATE_CLEAN_REQUEST,
  MESSAGE_TEMPLATE_DROPDOWN_FETCH_REQUEST,
  MESSAGE_TEMPLATE_DROPDOWN_FETCH_REQUEST_SUCCESS,
  MESSAGE_TEMPLATE_DROPDOWN_FETCH_REQUEST_FAILURE,
  MESSAGE_UNREAD_COUNT_FETCH_REQUEST,
  MESSAGE_UNREAD_COUNT_FETCH_REQUEST_SUCCESS,
  MESSAGE_UNREAD_COUNT_FETCH_REQUEST_FAILURE,
  EMAIL_TEMPLATE_TYPE_FETCH_REQUEST,
  EMAIL_TEMPLATE_TYPE_FETCH_REQUEST_SUCCESS,
  EMAIL_TEMPLATE_TYPE_FETCH_REQUEST_FAILURE,
  EMAIL_TEMPLATE_FIELD_FETCH_REQUEST,
  EMAIL_TEMPLATE_FIELD_FETCH_REQUEST_SUCCESS,
  EMAIL_TEMPLATE_FIELD_FETCH_REQUEST_FAILURE,
  MESSAGE_TEMPLATE_UPDATE_CLEAN_REQUEST,
  FETCH_DRAFT_MESSAGES,
  FETCH_DRAFT_MESSAGES_SUCCESS,
  FETCH_DRAFT_MESSAGES_FAILURE,
  SINGLE_DRAFT_MESSAGE_FETCH_REQUEST,
  SINGLE_DRAFT_MESSAGE_FETCH_REQUEST_SUCCESS,
  SINGLE_DRAFT_MESSAGE_FETCH_REQUEST_FAILURE,
  DRAFT_MESSAGE_UPSERT_REQUEST,
  DRAFT_MESSAGE_UPSERT_REQUEST_SUCCESS,
  DRAFT_MESSAGE_UPSERT_REQUEST_FAILURE,
  DRAFT_MESSAGE_DELETE_REQUEST,
  DRAFT_MESSAGE_DELETE_REQUEST_SUCCESS,
  DRAFT_MESSAGE_DELETE_REQUEST_FAILURE,
  DRAFT_MESSAGE_CLEAN_REQUEST,
  SINGLE_DRAFT_MESSAGE_CLEAN_REQUEST,
  FETCH_REPLY_MESSAGES_REQUEST,
  FETCH_REPLY_MESSAGES_REQUEST_SUCCESS,
  FETCH_REPLY_MESSAGES_REQUEST_FAILURE,
  CLEAN_THREAD_MESSAGE_REPLY,
  MARK_MESSAGE_AS_UNREAD,
  MARK_MESSAGE_AS_UNREAD_SUCCESS,
  MARK_MESSAGE_AS_UNREAD_FAILURE,
  MESSAGE_ATTACHMENTS_DOWNLOAD_BULK_REQUEST,
  MESSAGE_ATTACHMENTS_DOWNLOAD_BULK_REQUEST_SUCCESS,
  MESSAGE_ATTACHMENTS_DOWNLOAD_BULK_REQUEST_FAILURE,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  singlePayload: [],
  singleLoading: false,
  singleErrors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  dropdown: [],
  dropdownLoading: false,
  dropdownErrors: {},
  messageUnreadCountPayload: [],
  messageUnreadCountLoading: false,
  messageUnreadCountErrors: {},
  messageTemplateUpdate: [],
  messageTemplateUpdateLoading: false,
  messageTemplateUpdateErrors: {},
  emailTemplateType: [],
  emailTemplateTypeLoading: false,
  emailTemplateTypeErrors: {},
  emailTemplateFields: [],
  emailTemplateFieldsLoading: false,
  emailTemplateFieldsErrors: {},
  draftMsgPayload: [],
  draftMsgPayloadLoading: false,
  draftMsgPayloadErrors: {},
  draftMsgPagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  draftMsgUpsert: [],
  draftMsgUpsertLoading: false,
  draftMsgUpsertErrors: {},
  singleDraftMsg: [],
  singleDraftMsgLoading: false,
  singleDraftMsgErrors: {},
  deleteDraftMsg: [],
  deleteDraftMsgLoading: false,
  deleteDraftMsgErrors: {},
  messageReplies: [],
  messageRepliesLoading: false,
  messageRepliesErrors: {},
  markMessageAsUnreadPayload: [],
  markMessageAsUnreadPayloadLoading: false,
  markMessageAsUnreadPayloadErrors: {},
  messageAttachmentsDownloadBulk: [],
  messageAttachmentsDownloadBulkLoading: false,
  messageAttachmentsDownloadBulkErrors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const messageReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case MESSAGE_ADD_REQUEST:
    case MESSAGE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SINGLE_MESSAGE_FETCH_REQUEST:
      return Object.assign({}, state, {
        singleLoading: true,
      });

    case SINGLE_MESSAGE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleLoading: false,
        singlePayload: action.data,
        singleErrors: {},
      });

    case MESSAGE_ADD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case MESSAGE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });

    case SINGLE_MESSAGE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleLoading: false,
        singleErrors: action.error,
        singlePayload: undefined,
      });

    case MESSAGE_ADD_REQUEST_FAILURE:
    case MESSAGE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case MESSAGE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    case SINGLE_MESSAGE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        singlePayload: [],
        // singleLoading: false,
        singleErrors: {},
      });

    case MESSAGE_UNREAD_COUNT_FETCH_REQUEST:
      return Object.assign({}, state, {
        messageUnreadCountLoading: true,
      });

    case MESSAGE_UNREAD_COUNT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        messageUnreadCountLoading: false,
        messageUnreadCountPayload: action.data,
        messageUnreadCountErrors: {},
      });

    case MESSAGE_UNREAD_COUNT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        messageUnreadCountLoading: false,
        messageUnreadCountErrors: action.error,
      });

    case FETCH_REPLY_MESSAGES_REQUEST:
      return Object.assign({}, state, {
        messageRepliesLoading: true,
      });

    case FETCH_REPLY_MESSAGES_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        messageRepliesLoading: false,
        messageReplies: action.data,
        messageRepliesErrors: {},
      });

    case FETCH_REPLY_MESSAGES_REQUEST_FAILURE:
      return Object.assign({}, state, {
        messageRepliesLoading: false,
        messageRepliesErrors: action.error,
      });

    case CLEAN_THREAD_MESSAGE_REPLY:
      return Object.assign({}, state, {
        messageRepliesLoading: false,
        messageReplies: [],
        messageRepliesErrors: {},
      });

    case MESSAGE_ATTACHMENTS_DOWNLOAD_BULK_REQUEST:
      return Object.assign({}, state, {
        messageAttachmentsDownloadBulkLoading: true,
        messageAttachmentsDownloadBulk: [],
        messageAttachmentsDownloadBulkErrors: {},
      });

    case MESSAGE_ATTACHMENTS_DOWNLOAD_BULK_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        messageAttachmentsDownloadBulkLoading: false,
        messageAttachmentsDownloadBulk: action.data,
        messageAttachmentsDownloadBulkErrors: {},
      });

    case MESSAGE_ATTACHMENTS_DOWNLOAD_BULK_REQUEST_FAILURE:
      return Object.assign({}, state, {
        messageAttachmentsDownloadBulkLoading: false,
        messageAttachmentsDownloadBulkErrors: action.error,
      });

    default:
      return state;
  }
};

export default messageReducer;

/**
 * A reducer takes two arguments, the current state and an action.
 */
export const messageTemplateReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case MESSAGE_TEMPLATE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case MESSAGE_TEMPLATE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });

    case MESSAGE_TEMPLATE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case MESSAGE_TEMPLATE_UPSERT_REQUEST:
      return Object.assign({}, state, {
        messageTemplateUpdateLoading: true,
      });

    case MESSAGE_TEMPLATE_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        messageTemplateUpdate: action.data,
        messageTemplateUpdateLoading: false,
        messageTemplateUpdateErrors: {},
      });

    case MESSAGE_TEMPLATE_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        messageTemplateUpdateLoading: false,
        messageTemplateUpdateErrors: action.error,
      });

    case MESSAGE_TEMPLATE_DROPDOWN_FETCH_REQUEST:
      return Object.assign({}, state, {
        dropdownLoading: true,
      });

    case MESSAGE_TEMPLATE_DROPDOWN_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        dropdown: action.data,
        dropdownLoading: false,
        dropdownErrors: {},
      });

    case MESSAGE_TEMPLATE_DROPDOWN_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        dropdownLoading: false,
        dropdownErrors: action.error,
      });

    case EMAIL_TEMPLATE_TYPE_FETCH_REQUEST:
      return Object.assign({}, state, {
        emailTemplateTypeLoading: true,
      });

    case EMAIL_TEMPLATE_TYPE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        emailTemplateType: action.data,
        emailTemplateTypeLoading: false,
        emailTemplateTypeErrors: {},
      });

    case EMAIL_TEMPLATE_TYPE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        emailTemplateTypeLoading: false,
        emailTemplateTypeErrors: action.error,
      });

    case EMAIL_TEMPLATE_FIELD_FETCH_REQUEST:
      return Object.assign({}, state, {
        emailTemplateFieldsLoading: true,
      });

    case EMAIL_TEMPLATE_FIELD_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        emailTemplateFields: action.data,
        emailTemplateFieldsLoading: false,
        emailTemplateFieldsErrors: {},
      });

    case EMAIL_TEMPLATE_FIELD_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        emailTemplateFieldsLoading: false,
        emailTemplateFieldsErrors: action.error,
      });

    case MESSAGE_TEMPLATE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
        emailTemplateType: [],
        emailTemplateTypeLoading: false,
        emailTemplateTypeErrors: {},
        emailTemplateFields: [],
        emailTemplateFieldsLoading: false,
        emailTemplateFieldsErrors: {},
      });

    case MESSAGE_TEMPLATE_UPDATE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        messageTemplateUpdateErrors: {},
      });

    default:
      return state;
  }
};

export const draftMsgReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case FETCH_DRAFT_MESSAGES:
      return Object.assign({}, state, {
        draftMsgPayloadLoading: true,
      });

    case FETCH_DRAFT_MESSAGES_SUCCESS:
      return Object.assign({}, state, {
        draftMsgPayloadLoading: false,
        draftMsgPayload: action.data,
        draftMsgPayloadErrors: {},
        draftMsgPagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });

    case FETCH_DRAFT_MESSAGES_FAILURE:
      return Object.assign({}, state, {
        draftMsgPayloadLoading: false,
        draftMsgPayloadErrors: action.error,
      });

    case SINGLE_DRAFT_MESSAGE_FETCH_REQUEST:
      return Object.assign({}, state, {
        singleDraftMsgLoading: true,
      });

    case SINGLE_DRAFT_MESSAGE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleDraftMsgLoading: false,
        singleDraftMsg: action.data,
        singleDraftMsgErrors: {},
      });

    case SINGLE_DRAFT_MESSAGE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleDraftMsgLoading: false,
        singleDraftMsgErrors: action.error,
      });

    case DRAFT_MESSAGE_UPSERT_REQUEST:
      return Object.assign({}, state, {
        draftMsgUpsertLoading: true,
      });

    case DRAFT_MESSAGE_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        draftMsgUpsertLoading: false,
        draftMsgUpsert: action.data,
        draftMsgUpsertErrors: {},
      });

    case DRAFT_MESSAGE_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        draftMsgUpsertLoading: false,
        draftMsgUpsertErrors: action.error,
      });

    case DRAFT_MESSAGE_DELETE_REQUEST:
      return Object.assign({}, state, {
        deleteDraftMsgLoading: true,
      });

    case DRAFT_MESSAGE_DELETE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        deleteDraftMsgLoading: false,
        deleteDraftMsg: action.data,
        deleteDraftMsgErrors: {},
      });

    case DRAFT_MESSAGE_DELETE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        deleteDraftMsgLoading: false,
        deleteDraftMsgErrors: action.error,
      });

    case DRAFT_MESSAGE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        draftMsgPayload: [],
        draftMsgPayloadLoading: false,
        draftMsgPayloadErrors: {},
        draftMsgPagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    case SINGLE_DRAFT_MESSAGE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        singleDraftMsg: [],
        singleDraftMsgLoading: false,
        singleDraftMsgErrors: {},
        draftMsgUpsertLoading: false,
        draftMsgUpsert: [],
        draftMsgUpsertErrors: {},
      });

    case MARK_MESSAGE_AS_UNREAD:
      return Object.assign({}, state, {
        markMessageAsUnreadPayloadLoading: true,
      });

    case MARK_MESSAGE_AS_UNREAD_SUCCESS:
      return Object.assign({}, state, {
        markMessageAsUnreadPayloadLoading: false,
        markMessageAsUnreadPayload: action.data,
        markMessageAsUnreadPayloadErrors: {},
      });

    case MARK_MESSAGE_AS_UNREAD_FAILURE:
      return Object.assign({}, state, {
        markMessageAsUnreadPayloadLoading: false,
        markMessageAsUnreadPayloadErrors: action.error,
      });

    default:
      return state;
  }
};
